import styled from "@emotion/styled/macro";

export const VaultListTagsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
    min-width: 0;
`;

export const VaultListTagWrapper = styled.div`
    display: ${({ alwaysShow }) => alwaysShow ? "flex" : "none"};
    height: 28px;
    padding: 0px 12px 0px ${({ withIcon }) => withIcon ? "6px" : "12px"};
    align-items: center;
    gap: 6px;
    flex-shrink: 0;

    border-radius: 37px;

    color: #1A1B1D;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
`;

export const VaultListTagWrapperText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
`;

export const VaultTagEllipsis = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0px 8px;
    border-radius: 37px;
    background: #E9EAEB;
    color: #1A1B1D;
    font-size: 12px;
    font-weight: 450;
    white-space: nowrap;
`;

export const VaultClassTagIconWrapper = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 4px;
    justify-content: center;
    align-items: center;

    border-radius: 25.333px;
    background: ${({ bgColor }) => bgColor};

    path {
        fill: #fff;
    }
`;